var forNumber = function (list, j, issueResult, i, isLosts) {
  var arr = [];
  var islost = true;
  for (let z = 0; z < list.length; z++) {
    var obj = {};
    const n = list[z];
    obj.number = n;
    obj.bingo = false;
    obj.x = z;
    obj.y = j;
    if (n == 0) {
      obj.bingo = true;
      obj.number = issueResult[j];
      islost = false;
    }
    obj.isLost = islost;
    arr.push(obj);
  }
  return arr;
};

var forLost = function (obj, i, isLosts) {
  var arr = [];
  // for (let z = 0; z < obj.lostInfo.length; z++) {
  //   isLosts[z].push([]);
  // }
  for (let j = 0; j < obj.lostInfo.length; j++) {
    const l = obj.lostInfo[j];
    var numList = forNumber(l, j, obj.issueResult, i, isLosts);
    arr.push(numList);
  }
  return arr;
};
// var formatLost = function(params) {
//   var reruilt = [];
//   var isLosts = [];
//   params.map((v, n) => {
//     isLosts.push([]);
//     v.lostInfo.map((o, l) => {
//       isLosts[n].push([]);
//       // o.map((num, j) => {
//       //   isLosts[n][j] = true;
//       // });
//     });
//   });
//   for (let i = 0; i < params.length; i++) {
//     var obj = {};
//     const e = params[i];
//     obj.issueId = e.issueId;
//     obj.issueResult = e.issueResult;
//     obj.lost = forLost(e, i, isLosts);
//     reruilt.push(obj);
//   }
// };

var formatReuilt = function (arr, shape, start, end) {
  // console.log(start, end);

  for (let i = 0; i < arr.length; i++) {
    arr[i].ball_json = JSON.parse(arr[i].ball_json);
    arr[i].form_json = JSON.parse(arr[i].form_json);
    arr[i].lh_json = JSON.parse(arr[i].lh_json);
    arr[i].sum_json = JSON.parse(arr[i].sum_json);
    arr[i].List = arr[i].balls.split(',');
    arr[i].ballList = arr[i].balls.split(',').slice(start, end);
    arr[i].shape = arr[i].form_json[shape].shape;
    arr[i].join = arr[i].form_json[shape].join;
  }
  return arr;
};

var formatLonghu = function (arr) {
  for (let i = 0; i < arr.length; i++) {
    arr[i].ball_json = JSON.parse(arr[i].ball_json);
    arr[i].form_json = JSON.parse(arr[i].form_json);
    arr[i].lh_json = JSON.parse(arr[i].lh_json);
    arr[i].sum_json = JSON.parse(arr[i].sum_json);
    var ball = arr[i].balls.split(',');
    var len = ball.length;
    arr[i].ballList = [];
    arr[i].ballList.push(ball[0]);
    arr[i].ballList.push(ball[len - 1]);
    // arr[i].join = arr[i].form_json[shape].join;
  }
  return arr;
};
var formatJson = function (arr) {
  for (let i = 0; i < arr.length; i++) {
    for (const k in arr[i]) {
      if (arr[i].hasOwnProperty(k) && k.includes('json') && arr[i][k] != '') {
        arr[i][k] = JSON.parse(arr[i][k]);
      }
    }
  }
  return arr;
};
var formatSscDingwei = function (arr, index) {

  for (let i = 0; i < arr.length; i++) {
    arr[i].ball_json = JSON.parse(arr[i].ball_json);
    arr[i].form_json = JSON.parse(arr[i].form_json);
    arr[i].lh_json = JSON.parse(arr[i].lh_json);
    arr[i].sum_json = JSON.parse(arr[i].sum_json);
    var ball = arr[i].balls.split(',');

    ball = ball.sort((a, b) => a - b)

    arr[i].ballList = ball;

    // var key = Object.keys(arr[i].ball_json)[index];

    //取出相对应的球号数据，后端前缀统一都是ball  球一：ball1 球二：ball2 .....
    arr[i].ballObj = arr[i].ball_json[`ball${index + 1}`];

  }
  return arr;
};

var formatKsDingwei = function (arr, index) {

  for (let i = 0; i < arr.length; i++) {
    arr[i].ball_json = JSON.parse(arr[i].ball_json);
    arr[i].form_json = JSON.parse(arr[i].form_json);
    arr[i].lh_json = JSON.parse(arr[i].lh_json);
    arr[i].sum_json = JSON.parse(arr[i].sum_json);
    var ball = arr[i].balls.split(',');
    ball = ball.sort((a, b) => a - b);

    arr[i].ballList = ball;
  }
  return arr;
};

var formatLost = function (arg) {
  var o = {
    allOpen: '出现次数', //出现次数
    // joinOpen: "当前连开",
    // averageOmit: "平均遗漏",
    maxOmit: '最大遗漏', //
    maxJoin: '最大连出' //
    // nowOmit: "当前遗漏"
  };
  var arr = [];
  for (const key in o) {
    var obj = {};
    obj.name = o[key];
    obj.key = key;
    obj.lost = arg;
    arr.push(obj);
  }
  return arr;
};
export default {
  formatLost,
  formatReuilt,
  formatLonghu,
  formatSscDingwei,
  formatKsDingwei,
  formatJson
  // formatLost
};



// WEBPACK FOOTER //
// ./src/helpers/format.js